// extracted by mini-css-extract-plugin
export var footer = "_p9-0";
export var inherit = "_p9-1";
export var input = "_p9-2";
export var modalContent = "_p9-3";
export var quillEditor = "_p9-4";
export var subtitle = "_p9-5";